export interface StorageInfo {
  persisted: boolean | null; // null = API unsupported
  usageBytes: number | null;
  quotaBytes: number | null;
}

export async function requestPersistentStorage(): Promise<boolean | null> {
  if (!navigator.storage?.persist) return null;
  try {
    return await navigator.storage.persist();
  } catch {
    return null;
  }
}

export async function getStorageInfo(): Promise<StorageInfo> {
  let persisted: boolean | null = null;
  let usageBytes: number | null = null;
  let quotaBytes: number | null = null;

  if (navigator.storage?.persisted) {
    try {
      persisted = await navigator.storage.persisted();
    } catch {
      persisted = null;
    }
  }

  if (navigator.storage?.estimate) {
    try {
      const estimate = await navigator.storage.estimate();
      usageBytes = estimate.usage ?? null;
      quotaBytes = estimate.quota ?? null;
    } catch {
      usageBytes = null;
      quotaBytes = null;
    }
  }

  return { persisted, usageBytes, quotaBytes };
}
